const { h, render, Component } = require('preact');
const ID = require('./id')
const PurchaseDate = require('./purchase_date')
const Gift = require('./gift')
const Quantity = require('./quantity')
const CheckInInfo = require('./check_in_info')
const CheckOutInfo = require('./check_out_info')

class GetawaysBookingTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <table class="first-table">
        <ID orderDetails={this.props.orderDetails}/>
        <PurchaseDate orderDetails={this.props.orderDetails}/>
        <Gift orderDetails={this.props.orderDetails}/>
        <Quantity orderDetails={this.props.orderDetails}/>
        <CheckInInfo orderDetails={this.props.orderDetails}/>
        <CheckOutInfo orderDetails={this.props.orderDetails}/>
      </table>
    );
  }
}
module.exports = GetawaysBookingTable
